<template>
  <div class="mine">
    <div class="header">
      <div class="left">
        <div class="avatar">
          <img :src="avatar" alt="" />
        </div>
        <div class="info">
          <div class="name flex flex-vc">
            {{ name }}
            <div
              style="margin-left: 0.5rem;"
              v-if="$store.state.vipData.length > 0"
            >
              <img
                src="@/assets/vip.png"
                alt=""
                style="width: 1rem; margin-right: 0.3rem;"
              />
            </div>
          </div>
          <div class="dept" v-if="$store.state.vipData.length > 0">
            {{ getDateYMD($store.state.vipData[0].dueTime) }}到期
          </div>
          <div class="dept">{{ guestCompany }}</div>
        </div>
      </div>
      <div class="btn" @click="$router.push('/profile')">
        <i class="iconfont" style="font-size: 0.9em; margin-left: 0.3em;"
          >&#xe607;</i
        >
      </div>
    </div>
    <div class="body">
      <van-cell-group>
        <van-cell
          title="我的审批"
          size="large"
          v-if="userType == 13"
          @click="$router.push('myApproval')"
        >
          <template #icon>
            <!-- <div class="iconfont">&#xe62f;</div> -->
            <img
              src="@/assets/images/m3.png"
              alt=""
              width="20"
              height="20"
              style="margin-right: 1em;"
            />
          </template>
        </van-cell>
        <!-- v-if="userType == 2" -->
        <van-cell
          title="我的预约"
          size="large"
          @click="$router.push('visited-history')"
        >
          <template #icon>
            <!-- <div class="iconfont">&#xe67d;</div> -->
            <img
              src="@/assets/images/m3.png"
              alt=""
              width="20"
              height="20"
              style="margin-right: 1em;"
            />
          </template>
        </van-cell>
        <!-- <van-cell
          title="我的识别照片"
          size="large"
          @click="$router.push('avatar')"
        >
          <template #icon>
            <img
              src="@/assets/images/m4.png"
              alt=""
              width="20"
              height="20"
              style="margin-right: 1em;"
            />
          </template>
        </van-cell> -->

        <!-- <van-cell
          title="wxupload"
          size="large"
          @click="$router.push('wxupload')"
        >
          <template #icon>
            <div class="iconfont">&#xe689;</div>
          </template>
        </van-cell> -->
        <!-- <van-cell
          title="切换身份"
          size="large"
          @click="$router.push('role')"
        >
          <template #icon>
            <div class="iconfont" style="color: #ff4f9a;">&#xe62b;</div>
          </template>
        </van-cell> -->
        <template v-if="userType == 12">
          <van-cell
            title="开通会员"
            size="large"
            @click="$router.push('openVip')"
          >
            <template #icon>
              <img
                src="@/assets/images/m6.png"
                alt=""
                width="20"
                height="20"
                style="margin-right: 1em;"
              />
            </template>
          </van-cell>
          <van-cell
            title="我的订阅"
            size="large"
            @click="$router.push('orderlist')"
          >
            <template #icon>
              <img
                src="@/assets/images/m7.png"
                alt=""
                width="20"
                height="20"
                style="margin-right: 1em;"
              />
            </template>
          </van-cell>
          <!-- v-if="
              $store.state.vipData.length > 0 &&
              $store.state.vipData[0].userNumber > 1
            " -->
          <van-cell
            title="服务绑定"
            size="large"
            @click="$router.push('bindService')"
            v-if="
              $store.state.vipData.length > 0 &&
                $store.state.vipData[0].userNumber > 1
            "
          >
            <template #icon>
              <img
                src="@/assets/images/m8.png"
                alt=""
                width="20"
                height="20"
                style="margin-right: 1em;"
              />
            </template>
          </van-cell>
        </template>
        <van-cell
          title="切换身份"
          size="large"
          @click="$router.push('schoolList')"
          v-if="list.length > 1"
        >
          <template #icon>
            <!-- <div class="iconfont">&#xe689;</div> -->
            <img
              src="@/assets/images/m1.png"
              alt=""
              width="20"
              height="20"
              style="margin-right: 1em;"
            />
          </template>
        </van-cell>
        <van-cell
          title="通知设置"
          size="large"
          v-if="userType != 2 && showNotice && $store.state.vipData.length > 0"
          @click="$router.push('notice-setting')"
        >
          <template #icon>
            <img
              src="@/assets/images/m5.png"
              alt=""
              width="20"
              height="20"
              style="margin-right: 1em;"
            />
          </template>
        </van-cell>
        <van-cell title="清除缓存" size="large" @click="clearCache">
          <template #icon>
            <!-- <div class="iconfont">&#xe6bd;</div> -->
            <img
              src="@/assets/images/m2.png"
              alt=""
              width="20"
              height="20"
              style="margin-right: 1em;"
            />
          </template>
        </van-cell>
        <!-- <a href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MjM5MDYwNTAyNA==&scene=126&bizpsid=0&subscene=0#wechat_redirect" title="">关注公众号</a> -->
      </van-cell-group>
    </div>
    <!-- <van-button type="info" style="margin-left: 1em;" @click="clearCache"
      >清除缓存</van-button
    > -->
    <!-- <van-button type="info" style="margin-left: 1em;"
    @click="logOut">退出登录</van-button> -->
  </div>
</template>

<script>
let img = require('@/assets/images/avatar.png')
// import { compare, getDateYMD, timeFormart } from '@/utils'
import moment from 'moment'
export default {
  data() {
    return {
      // 2 - 访客
      userType: '',
      avatar: null,
      name: '',
      guestCompany: '',
      list: [],
      showNotice: false,
    }
  },
  activated() {
    let userInfo =
      sessionStorage.getItem('userInfo') &&
      JSON.parse(sessionStorage.getItem('userInfo'))
    if (!userInfo.mobile) {
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: '检测到您未绑定手机号，是否绑定手机号？',
        })
        .then(() => {
          // on confirm
          this.$router.push('/bindPhone')
        })
        .catch(() => {
          // on cancel
        })
    }
  },
  created() {
    let userInfo =
      sessionStorage.getItem('userInfo') &&
      JSON.parse(sessionStorage.getItem('userInfo'))
    if (userInfo) {
      this.userType = userInfo.personType
      this.avatar = userInfo.avatar || img
      this.name = userInfo.name
      this.guestCompany = userInfo.guestCompany
    }
    this.getSchoolList()
    this.getSysSchool()
    this.getUserBindPerson()

    // if (userInfo.personType == 12) {
    // }
  },
  computed: {
    // isVip() {
    //   return this.$store.state.userId == '1070916847500578816'
    // },
  },
  methods: {
    getDateYMD(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    logOut() {
      sessionStorage.removeItem('userInfo')
      this.$router.push('/register')
    },
    clearCache() {
      localStorage.removeItem('__sub__')
      this.$toast('清除缓存成功')
    },
    async getSchoolList() {
      const { code, data } = await this.$https.getSchoolList({
        userId: this.$store.state.userId,
      })
      if (code !== 200) {
        this.list = []
        return false
      }
      this.list = data
    },
    async getSysSchool() {
      const { data, code, msg } = await this.$https.getSysSchool({
        // dictType: 'school_function_param',
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200 && data.length == 0) {
        // this.$toast('')
        return
      }
      this.showNotice =
        data.length > 0 && data.some((item) => item.functionDictCode == 1)
    },
    async getUserBindPerson() {
      const { code, data } = await this.$https.getUserBindPerson({
        authUserId: this.$store.state.userId,
        schoolId: this.$store.state.schoolId,
      })
      if (code !== 200) {
        return
      }
      this.$store.commit('setVipData', data)
    },
  },
  computed: {
    getPersonName() {
      return (
        sessionStorage.getItem('userInfo') &&
        JSON.parse(sessionStorage.getItem('userInfo')).name
      )
    },
  },
}
</script>

<style lang="scss" scoped>
$border-color: rgba(244, 244, 246, 0.99);

@function px2rem($px) {
  @return $px / 16px * 1rem;
}

.mine {
  margin: 0.6em;
  box-shadow: 0px 4px 16px rgba(69, 91, 99, 0.08);
  background: #fff;
  border-radius: 0.3em;
  overflow: hidden;

  .header {
    display: flex;
    padding: 1.2em;
    justify-content: space-around;
    align-items: center;
    background: #fff;

    .left {
      display: flex;
      flex: 1;

      .avatar {
        /* height: px2rem(66px);
        width: px2rem(66px); */
        height: 3.9rem;
        width: 3.9rem;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
        }
      }

      .info {
        padding-left: 0.6em;
        display: flex;
        flex-direction: column;
        flex: 1;
        justify-content: center;

        .name {
          font-size: px2rem(24px);
        }

        .dept {
          font-size: px2rem(12px);
          color: #cad1e2;
        }
      }
    }

    .btn {
      background: transparent;
      /* width: px2rem(80px); */
      height: px2rem(32px);
      line-height: px2rem(32px);
      font-size: px2rem(14px);
      color: #cad1e2;
      font-weight: 400;
      border-radius: 3px;
      text-align: center;
    }
  }

  .iconfont {
    margin-right: 0.4em;
    font-size: 1rem;
  }
}
</style>
